export const Experiments = {
  PremiumBlockUoU: 'specs.invoices.PremiumBlockUoU',
  PriceQuoteTaxedLineTotals: 'specs.pricequotes.taxedLineTotals',
  BmHarmonyTheme: 'bmHarmonyTheme',
  // Authenticate the UoU cashier widget with a visitor-bound app instance so
  // the charge request carries a person identity and captcha can validate it.
  InvoicesUoUVisitorInstance: 'specs.crm.InvoicesUoUVisitorInstance',
} as const;
